import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchCountryField, TooltipLabel, CountryISO } from 'ngx-intl-tel-input';
import { ToastrService } from 'ngx-toastr';
import { MessageService } from 'src/app/common/events/message.service';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { RsbService } from 'src/app/service/rsb.service';
import { PatternValidatorsService } from 'src/app/common/services/pattern-validators.service';
@Component({
  selector: 'app-login-associate',
  templateUrl: './login-associate.component.html',
  styleUrls: ['./login-associate.component.css']
})
export class LoginAssociateComponent implements OnInit {
  @Input() successLink: string;
  loginForm: FormGroup;
  signupForm: FormGroup;
  loginSubs: any;
  loginBlocked: boolean = false;
  isMobileLayout: boolean = false;

  loginFailed: boolean = false;
  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  TooltipLabel = TooltipLabel;
  mobileotpVerified: boolean = false;
  CountryISO = CountryISO;
  onlyCountries = [];
  selectedISOCountry;
  passwordError: boolean = false;
  passworderr: string;
  passwordStrength: string;
  loginApplicationForm: boolean = false;
  hidePassword: boolean = true;
  mobileOtpVerified: boolean = false;
  previousLoginTime: string | null = null;
  mobileOtpCheck: boolean = false;
  mobileOtpError: boolean = false;
  mobileExists: boolean = false;
  mobileOtpSent: boolean = false;
  mobileOtpResent: boolean = false;
  mobileOtpMaxFlag: boolean = false;
  incorrectOtp: boolean = false;
  success_message: string;
  error_message: string;

  constructor(private router: Router,
    private fb: FormBuilder,
    // activeModal: NgbActiveModal,
    private rsbService: RsbService,
    private lookupModel: RsbLookupModel,
    private messageService: MessageService,
    private toastrService: ToastrService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.isMobileLayout = window.innerWidth <= 1024;
    window.onresize = () => this.isMobileLayout = window.innerWidth <= 1024;
    this.loginForm = this.fb.group({
      loginMobile: ['', [Validators.required]],
      loginPassword: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(11)]]
    });

    this.signupForm = this.fb.group({
      mobile: ['', [Validators.required]],
      mobileOtp: ['', [Validators.required]],
      // password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(10), Validators.pattern(/^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{1,10}$/)]],
      password: ['', [
        Validators.required,
        PatternValidatorsService.patternValidators({
          hasNumber: true,
          hasCapitalCase: true,
          hasSmallCase: true,
          hasSpecialCharacters: true,
          hasLength: true
        }),
      ]],

      email: ['', [Validators.required, Validators.email]],
      firstName: ['', [Validators.required, Validators.pattern('[a-zA-Z ]*')]]
    });

    const localCountrys = this.lookupModel.getCountryList();
    this.onlyCountries = [];
    localCountrys.forEach(country => {
      let isoCountry = this.findCountryIso(country.twoDigitCountryCode);
      if (isoCountry) {
        this.onlyCountries.push(isoCountry);
      }
    });
    const country = this.lookupModel.getCountry();
    if (country) {
      let isoCountry = this.findCountryIso(country.twoDigitCountryCode);
      if (isoCountry) {
        this.selectedISOCountry = isoCountry;
      }
    }
    this.previousLoginTime = this.rsbService.getLastLoginTime();


  }
  passwords: string = '';



  togglePassword(): void {
    this.hidePassword = !this.hidePassword;
  }
  findCountryIso(countryCode: string): string {
    let isoKey = Object.keys(CountryISO).find(item => CountryISO[item] === countryCode.toLowerCase());
    if (isoKey) {
      return CountryISO[isoKey];
    } else {
      return '';
    }
  }
  forgotPwd(): void {

    this.router.navigate(["forgotpassword"])



  }


  onlyNumbersAllowed(event): boolean {
    const charCode = event.which || event.keyCode;
    if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122) || charCode === 32) {
      return true;
    }
    return false;

  }

  validatePassword(password) {
    const val = password.target.value;
    if (val.length < 6 || val.length > 10) {
      this.passwordError = true
    } else {
      this.passwordError = false;
    }
  }

  sendOtp(mobile: any): void {
    this.mobileotpVerified = false;
    this.mobileOtpSent = false;
    this.mobileOtpMaxFlag = false;
    this.success_message = '';
    this.error_message = '';
    this.incorrectOtp = false;

    const e164Number = mobile.e164Number;
    const mobileNumber = e164Number.replace(mobile.dialCode, '');
    this.rsbService.sendAssociateMobileOtp(mobileNumber, parseInt(mobile.dialCode).toString()).subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.mobile.disable();
        this.mobileOtpSent = true;
      } else if (rsp.statusCode === 1) {
        this.mobileOtpMaxFlag = true;
      } else if (rsp.statusCode === 3) {
        this.mobileExists = true;
      }
      else if (rsp.statusCode === 2) {
        this.mobileOtpMaxFlag = true;
      }
      else {
        this.mobileOtpError = true;
      }
    }, (err) => {
      this.mobileOtpSent = false;
    });
  }


  clearEmailStatus(): void {
    this.mobileOtpSent = false;
    this.mobileOtpError = false;
    this.mobileExists = false;
    this.mobileOtpVerified = false;
    this.mobileOtpResent = false;
    this.mobileOtpMaxFlag = false;
    this.loginFailed = false;
  }

  register(): void {
    this.clearEmailStatus()
    this.mobileOtpVerified = false;
    const mobile = this.mobile.value;
    const e164Number = mobile.e164Number;
    const mobileNumber = e164Number.replace(mobile.dialCode, '');
    this.rsbService.verifyMobileOtpForAssociateSignUp(this.mobileOtp.value, this.password.value,
      parseInt(mobile.dialCode),
      mobileNumber,
      mobile.countryCode, this.firstName.value, this.email.value).subscribe((rsp) => {
        this.mobileOtpCheck = true;
        if (rsp.statusCode === 0) {
          this.lookupModel.setProfileDisplayType(0);
          this.mobileOtpVerified = true;
          this.lookupModel.setMobileType(1);
          this.router.navigate(['dashboard'])
          this.rsbService.updateLoginTime();
        } else {
          this.mobileOtpVerified = false;
        }
      }, (err) => {
        this.mobileOtpSent = false;
      });
  }

  login(): void {
    //alert("getting into login");
    const logMobile = this.loginMobile.value;
    const e164Number = logMobile.e164Number;
    const logMobileNumber = e164Number.replace(logMobile.dialCode, '');
    this.rsbService.associateCustomerLogin(parseInt(logMobile.dialCode), logMobileNumber, this.loginPassword.value).subscribe((rsp) => {
      this.loginFailed = false;
      if (rsp.statusCode === 0) {
        this.router.navigate(['dashboard'])
        this.rsbService.updateLoginTime();
      } else if (rsp.statusCode === 2) {
        this.toastrService.error('you are blocked by administrator')
      }
      else {
        this.loginFailed = true;
        this.toastrService.error("Invalid mobile or password")
        setTimeout(() => {
          this.loginFailed = false
        }, 5000)
        //this.close();
      }
      //  ("going here");
    });
  }










  close(rsn?: any): void {
    //this.activeModal.close(rsn);
  }

  get mobileOtp() { return this.signupForm.get('mobileOtp'); }
  get mobile() { return this.signupForm.get('mobile'); }
  get password() { return this.signupForm.get('password'); }
  get firstName() { return this.signupForm.get('firstName'); }
  get email() { return this.signupForm.get('email'); }
  get loginMobile() { return this.loginForm.get('loginMobile'); }
  get loginPassword() { return this.loginForm.get('loginPassword'); }

}
